const trimSlash = (value = "") => value.replace(/\/+$/, "");

const authUrl = trimSlash(process.env.REACT_APP_SSO_AUTH_URL);

export const ssoConfig = {
  authUrl,
  clientId: process.env.REACT_APP_SSO_CLIENT_ID || "kriha-commerce",
  redirectUri:
    process.env.REACT_APP_SSO_REDIRECT_URI ||
    `${window.location.origin}/callback`,
  scope: "openid profile email",
  authorizeUrl: `${authUrl}/oauth2/authorize`,
  // Backend-mediated exchange: the Accounts backend holds the client secret.
  tokenUrl: `${authUrl}/api/auth/exchange-token`,
  refreshUrl: `${authUrl}/api/auth/refresh-token`,
  logoutUrl: `${authUrl}/connect/logout`,
};

// Clears local session and ends the Kriha Accounts session too.
export const ssoLogout = () => {
  const idToken = localStorage.getItem("id_token");
  ["token", "id_token", "refresh_token", "rmd"].forEach((k) =>
    localStorage.removeItem(k)
  );
  if (!authUrl) {
    window.location.href = "/login";
    return;
  }
  const q = new URLSearchParams({
    post_logout_redirect_uri: `${window.location.origin}/login`,
  });
  if (idToken && idToken !== "null") q.set("id_token_hint", idToken);
  window.location.href = `${ssoConfig.logoutUrl}?${q}`;
};
